import CityPageTemplate from "../city-template/CityPageTemplate";
import { meridianIDConfig } from "./data";

export default function MeridianIDPage() {
  return <CityPageTemplate config={meridianIDConfig} />;
}